import useSelectedProduct from "./useSelectedProduct"

const usePickupProduct = () => useSelectedProduct("pickup")

export default usePickupProduct
